import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Config } from '@/utils/Config';

export abstract class BaseServiceDefinition {
  private get apiBaseUrl(): string {
    return Config.Settings.ApiBaseUrl;
  }

  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({});

    this.axiosInstance.interceptors.request.use(
      async config => {
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
  }

  get(url: string): Promise<any> {
    return this.axiosInstance.get(this.apiBaseUrl + url);
  }

  post(url: string, body?: any): Promise<any> {
    return this.axiosInstance.post(this.apiBaseUrl + url, body);
  }

  protected async downloadFile(url: string, filename: string, params?: any) {
    const response = await this.axiosInstance.get(this.apiBaseUrl + url, {
      responseType: 'blob',
      params
    } as AxiosRequestConfig);

    // https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
    const blobData = [response.data];
    const blob = new Blob(blobData, {
      type: response.headers['content-type'] || 'application/octet-stream'
    });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were
      // revoked by closing the blob for which they were created.
      // These URLs will no longer resolve as the data backing
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const blobURL =
        window.URL && window.URL.createObjectURL
          ? window.URL.createObjectURL(blob)
          : window.webkitURL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();

      // Fixes "webkit blob resource error 1"
      setTimeout(() => {
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      }, 200);
    }
  }
}
